import React, {useEffect, useState} from 'react';
import axios from "axios";
import Cookies from "js-cookie";
import {SERVER_BASE_URL} from "../Constants";

function Dashboard() {

    const [data, setData] = useState(null);

    const fetchHummus = async () => {
        try {
            const token =  Cookies.get("token");


            const response = await axios.get(SERVER_BASE_URL + 'api/users', {
                headers: {
                    Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
                },
            });
            console.log(response.data);


            // Handle successful response
            if (response.status === 200) {
                console.log(response.data.message);
            } else {
                console.log(response);
            }
        } catch (err) {
            // Handle API errors
            console.log("error");
        }
    };

    fetchHummus();

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const token = localStorage.getItem('token');
    //
    //
    //             const response = await axios.get('/api/data', {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
    //                 },
    //             });
    //             console.log(response.data);
    //
    //
    //             // Handle successful response
    //             if (response.status === 200) {
    //                 setData(response.data);
    //                 console.log(response.data);
    //             } else {
    //                 console.log(response);
    //             }
    //         } catch (err) {
    //             // Handle API errors
    //             console.log("error");
    //         }
    //     };
    //
    //     fetchData();
    // }, []); // Runs only once on page load


    return (
        <div style={{textAlign: 'center', marginTop: '50px'}}>
            <h1>Welcome to the Dashboard</h1>
            <pre>{data ? JSON.stringify(data, null, 2) : 'Loading...'}</pre>
        </div>
    );
}

export default Dashboard;
